<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 工单客服数据 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <FilterCommon :model="filterModel" :isReset="true" @search="search" @reset="reset">
          <template v-slot:button>
            <el-button type="primary" @click="isCompare = !isCompare">{{ isCompare ? '取消对比' : '设置对比' }}</el-button>
          </template>
        </FilterCommon>
        <el-button v-if="set_time_button" class="filter-item" style="background-color: #00bfbf; color: white; float: right; position: relative; bottom: 50px" @click="setTime">时间限制</el-button>
        <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
          <el-table-column prop="date" label="时间区间" width="250" />
          <el-table-column prop="deal_user" label="处理人" width="150" />
          <el-table-column prop="deal_num" label="处理数" width="150" sortable />
          <el-table-column prop="operate_num" label="操作数" width="150" sortable />
          <el-table-column prop="average_time_text" label="平均处理时长" width="150" sortable />
          <el-table-column prop="average_response_time_text" label="平均响应时长" width="150" sortable />
          <el-table-column prop="wrong_number" label="出错数" width="150" sortable />
          <el-table-column prop="wrong_rate_text" label="出错率" width="150" sortable />
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="page" :limit.sync="limit" @pagination="handlePagination" />
        <setTimeRange :timeOptions="timeOptions" :setTimeShow="setTimeShow" @deleteTime="deleteTime" @addTime="addTime" @removeTime="removeTime" @sureTime="sureTime" @closeTimeShow="closeTimeShow">
        </setTimeRange>
      </div>
    </div>
  </div>
</template>
<script>
import { getWorksnDataApi } from '@/api/work_data.js';
import { getUserListApi } from '@/api/testAnalysis.js';
import { getTimeApi, setTimeApi } from '@/api/setTime.js';
import Pagination from '@/components/pagination/index';
import FilterCommon from '@/components/common/Filter';
import setTimeRange from '@/components/common/setTimeRange';
import dayjs from 'dayjs';

export default {
  components: { Pagination, FilterCommon, setTimeRange },
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      tableData: [],
      adminList: [],
      isCompare: false, // 是否设置对比
      defaultDate: dayjs(new Date(new Date())).format('YYYY-MM-DD'),
      searchParams: {
        page: 1,
        limit: 10,
        start_date: dayjs(new Date(new Date())).format('YYYY-MM-DD'),
        end_date: dayjs(new Date(new Date())).format('YYYY-MM-DD'),
      },
      // 时间设置
      timeOptions: [],
      setTimeShow: false,
      set_time_button: false,
    };
  },
  computed: {
    filterModel() {
      let model = [
        {
          span: 6,
          type: 'date-picker',
          label: '时间区间：',
          key: 'date',
          dateType: false,
          empty: false,
          showDefault: true,
        },
        {
          type: 'select',
          label: '工单客服：',
          key: 'admin_id',
          span: 4,
          isMultiple: true,
          options: this.adminList,
        },
      ];
      let compareModel = [
        {
          span: 6,
          type: 'date-picker',
          label: '时间区间：',
          key: 'date',
          dateType: false,
          empty: false,
          showDefault: true,
        },
        {
          type: 'select',
          label: '工单客服：',
          key: 'admin_id',
          span: 4,
          isMultiple: true,
          options: this.adminList,
        },
        {
          span: 6,
          type: 'date-picker',
          label: '时间区间：',
          key: 'compareDate',
          dateType: false,
          empty: false,
          showDefault: true,
        },
        {
          type: 'select',
          label: '工单客服：',
          key: 'admin_id_compare',
          span: 4,
          isMultiple: true,
          options: this.adminList,
        },
      ];
      return this.isCompare ? compareModel : model;
    },
  },
  created() {
    this.getTableList();
    this.getUserList();
  },
  methods: {
    // 获取table列表
    async getTableList() {
      const r = await getWorksnDataApi(this.searchParams);
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.tableData = r.data.data.data;
      this.total = r.data.data.total;
      this.set_time_button = r.data.data.time_button;
    },
    // 获取工单客服列表
    async getUserList() {
      const r = await getUserListApi();
      this.adminList = [...r.data.data];
    },
    // 搜索
    search(e) {
      let obj = {
        page: this.searchParams.page,
        limit: this.searchParams.limit,
        start_date: (e.date && e.date[0]) || this.defaultDate,
        end_date: (e.date && e.date[1]) || this.defaultDate,
        admin_id: e.admin_id,
      };
      this.searchParams = this.isCompare
        ? {
            ...obj,
            is_compare: 1,
            start_date_compare: (e.compareDate && e.compareDate[0]) || this.defaultDate,
            end_date_compare: (e.compareDate && e.compareDate[1]) || this.defaultDate,
            admin_id_compare: e.admin_id_compare,
          }
        : obj;
      this.getTableList();
    },
    // 重置
    reset() {
      this.searchParams = {
        page: 1,
        limit: 10,
        start_date: this.defaultDate,
        end_date: this.defaultDate,
      };
      this.isCompare = false;
      this.getTableList();
    },
    // 处理翻页
    handlePagination(obj) {
      this.searchParams = Object.assign(this.searchParams, {
        page: obj.page,
        limit: obj.limit,
      });
      this.getTableList();
    },
    setTime() {
      this.setTimeShow = true;
      this.timeOptions = [];
      let data = {};
      data.config_key = 'statistics.time_range';
      getTimeApi(data)
        .then((response) => {
          for (let item of response.data.data) {
            let m = {
              value: [],
              id: new Date(),
            };
            let time = item.split('-');
            m.value = time;
            this.timeOptions.push(m);
          }
        })
        .catch((error) => {});
    },
    deleteTime(item) {
      for (let i = 0; i < this.timeOptions.length; i++) {
        if (this.timeOptions[i].id == item.id) {
          this.timeOptions.splice(i, 1);
        }
      }
    },
    addTime() {
      let m = {
        value: ['00:00', '23:59'],
        id: new Date(),
      };
      this.timeOptions.push(m);
    },
    removeTime() {
      this.setTimeShow = false;
    },
    closeTimeShow() {
      this.setTimeShow = false;
    },
    sureTime() {
      let data = {
        config_values: [],
        config_key: '',
      };
      data.config_key = 'statistics.time_range';
      for (let item of this.timeOptions) {
        let time = '';
        if (!(item.value[0] == '00:00' && item.value[1] == '23:59')) {
          time = item.value[0] + '-' + item.value[1];
          data.config_values.push(time);
        }
      }
      setTimeApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.setTimeShow = false;
            this.$message.success(response.data.message);
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: rgb(248, 229, 229);
}
</style>
